import { hover } from "@testing-library/user-event/dist/hover";
import styled from "styled-components";
import stars from "../../assets/stars.png";
import twinkling from "../../assets/twinkling.png";

const MainContainer = styled.section`
  min-width: 100vw;
  min-height: 100vh;
  height: max-content;
  display: flex;
  justify-content: center;
  background-image: url(${stars});
  background-color: rgb(86, 41, 182);
`;
const SubContainer = styled.div`
  width: 80vw;
  min-width: 90vw;
  height: fit-content;
  min-height: 70vh;
  margin: 10vh 0px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 5vw;
  row-gap: 10vh;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 0;
  }
`;
const ContentWrapper = styled.div`
  width: 500px;
  height: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 0;
    min-height: fit-content;
    margin-bottom: 40px;
    & .chatBotSvg {
      height: 200px;
    }
  }
`;
const FormWrapper = styled.div`
  width: fit-content;
  height: 100%;
  min-height: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 3px;
  border-radius: 2px;
  margin-bottom: 16px;
`;
const FormColumn = styled.div`
  width: 275px;
  height: fit-content;
  padding: 70px 60px;
`;
const FormRow = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 5vw;
  row-gap: 5vh;
`;
const Title = styled.h2`
  color: rgb(103, 63, 189);
  font-size: 30px;
  font-weight: 400;
  margin: 0px 0px 50px;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const FormInput = styled.input`
  padding: 0px 0px 3px;
  color: rgb(57, 60, 64);
  font-size: 12px;
  font-weight: 200;
  outline: currentcolor none 0px;
  display: block;
  border-color: #000040;
  border-style: none none solid;
  border-width: medium medium 1px;
  width: 100%;
  height: 34px;
  background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
  transition: all 0.3s ease 0s;
  margin-bottom: 16px;
`;
const FormInputSelect = styled.select`
  padding: 0px 0px 3px;
  margin: 15px 0px 0px 0px;
  color: rgb(57, 60, 64);
  font-size: 12px;
  font-weight: 400;
  outline: currentcolor none 0px;
  display: block;
  border-color: #000040;
  border-style: none none solid;
  border-width: medium medium 1px;
  width: 100%;
  height: 34px;
  background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
  transition: all 0.3s ease 0s;
  margin-bottom: 16px;
  color: rgb(117, 117, 117);
  &:first-child {
    margin: 0px 0px 10px 0px;
  }
`;

const FormInputSelectOption = styled.option`
  color: rgb(44, 56, 63);
`;

const FormInputLabel = styled.label``;

const ButtonSuccessLarge = styled.button`
  text-transform: uppercase;
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgb(60, 204, 56) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(255, 255, 255) !important;
  display: block;
  width: 100%;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgb(46, 166, 42) none repeat scroll 0% 0%;
  }
`;

const ButtonSuccess = styled.button`
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgb(60, 204, 56) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(255, 255, 255) !important;
  display: block;
  width: fit-content;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgb(46, 166, 42) none repeat scroll 0% 0%;
  }
`;

const ButtonSecondaryLarge = styled.button`
  text-transform: uppercase;
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(136, 136, 136) !important;
  display: block;
  width: 100%;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  }
`;

const ButtonSecondary = styled.button`
  text-transform: uppercase;
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(136, 136, 136) !important;
  display: block;
  width: fit-content;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  }
`;

const FormFooterLink = styled.div`
  text-align: center;
  box-sizing: border-box;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  font-size: 13px !important;
  line-height: 1.53846;
  text-rendering: optimizelegibility;
  &:hover a {
    color: inherit;
    text-decoration: none;
  }
  }
`;

export {
  MainContainer,
  SubContainer,
  ContentWrapper,
  FormWrapper,
  FormColumn,
  FormRow,
  Title,
  Form,
  FormInput,
  FormInputLabel,
  FormInputSelect,
  FormInputSelectOption,
  ButtonSuccess,
  ButtonSuccessLarge,
  ButtonSecondaryLarge,
  FormFooterLink,
};
